(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict"; // legacy browser alert

function isLegacyIE() {
  var ua = navigator.userAgent;

  if (ua.indexOf("MSIE 6.0") != -1) {
    // Internet Explorer 6
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 7.0") != -1) {
    // Internet Explorer 7
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 8.0") != -1) {
    // Internet Explorer 8
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 9.0") != -1) {
    // Internet Explorer 9
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 10.0") != -1) {
    // Internet Explorer 10
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("Trident/7.0") != -1) {
    // Internet Explorer 11
    alert("ご利用のウェブブラウザでは当サイトを正常に閲覧できません。最新のブラウザで再度アクセスしてください。");
  } else {
    return false;
  }
}

isLegacyIE(); // news ticker slide

var mySwiper = new Swiper('#news_ticker', {
  direction: 'horizontal',
  loop: true,
  autoplay: {
    delay: 3000
  }
}); // topics pick up slide

var mySwiper = new Swiper('#topics_pickup', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 4,
  speed: 1500,
  spaceBetween: 24,
  autoplay: {
    delay: 3000
  },
  breakpoints: {
    480: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    }
  }
});
$(function () {
  // header effect
  $(window).on('scroll', function () {
    var scrollCount = $(this).scrollTop();

    if ("#header") {
      if (scrollCount < 300) {
        $("#header").addClass('l-header-sticky');
      } else {
        $("#header").removeClass('l-header-sticky');
      }
    }
  }); // drawer nav

  $("#hanburger").on('click', function () {
    $("#drawer").addClass('__active');
    $("#overlay").fadeIn();
  });
  $("#overlay, #close").on('click', function () {
    $("#drawer").removeClass('__active');
    $("#overlay").fadeOut();
  }); // dropdown menu

  $(".dropdownmenu_list_trigger").each(function () {
    $(this).on('mouseenter', function () {
      $(this).children('.dropdownmenu_list').stop().slideDown();
    });
    $(this).on('mouseleave', function () {
      $(this).children('.dropdownmenu_list').stop().slideUp();
    });
  }); // image roll over

  $(".roll_over").each(function () {
    $(this).on('mouseenter', function () {
      var hoverSrcUrl = $(this).attr('data-hover');
      $(this).attr('src', hoverSrcUrl);
    });
    $(this).on('mouseleave', function () {
      var srcUrl = $(this).attr('data-src');
      $(this).attr('src', srcUrl);
    });
  }); // tab panel

  $("#tab_label > li").on('click', function () {
    var i = $("#tab_label > li").index(this);
    $("#tab_panel > li").hide();
    $("#tab_panel > li").eq(i).show();
    $("#tab_label > li").removeClass('__active');
    $(this).addClass('__active');
  });
});

},{}]},{},[1]);
